/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import axios from '../../axios'

export default {
  ADD_AGREEMENTS (state, agreements) {
    state.agreements = [...state.agreements, ...agreements]
  },

  DELETE_AGREEMENT (state, uuid) {
    state.agreements = state.agreements.filter(x => x.uuid != uuid)
  },

  SET_REGISTER_AGREEMENTS (state, agreements) {
    state.registerAgreements = agreements
  },

  SET_AGREEMENTS_AS_REGISTER (state, uuid) {
    state.registerAgreements = state.agreements.filter(x => x.uuid == uuid)
  }

}
